import { FormControl, FormGroup, Validators } from '@angular/forms';
import { IResponse } from 'src/app/pages/base/interfaces';
import { MaestroModel } from '../maestro.model';
import { HistorialNotificacionService } from 'src/app/services/notificacion/historial_notificacion.service';


export class JobNotificacion extends MaestroModel {

    public static RECORD_NAME = 'jobs_procesamiento';
    public static CODIGO_REGISTRO = 'job_notificacion';
    public static CODIGO_MODULO = 'notificacion';
    public static NOMBRE_SINGULAR = 'Job de Notificación';
    public static NOMBRE_PLURAL = 'Jobs de Notificación';

    // Estados
    public static ESTADOS = [
        { valor: 'pendiente', nombre: 'Pendiente' },
        { valor: 'procesando', nombre: 'Procesando' },
        { valor: 'completado', nombre: 'Completado' },
        { valor: 'fallido', nombre: 'Fallido' },
        { valor: 'cancelado', nombre: 'Cancelado' }
    ];

    // Tipos
    public static TIPOS = [
        { valor: 'sms', nombre: 'SMS' },
        { valor: 'whatsapp', nombre: 'WhatsApp' },
        { valor: 'email', nombre: 'Correo' }
    ];

    // Tipos de origen
    public static TIPOS_ORIGEN = [
        { valor: 'contactos', nombre: 'Lista de Contactos' },
        { valor: 'excel', nombre: 'Archivo Excel/CSV' },
        { valor: 'seleccion', nombre: 'Selección Manual' }
    ];

    private _tipo: string;
    private _tipoOrigen: string;
    private _estado: string;
    private _totalRegistros: number;
    private _procesados: number;
    private _fallos: number;
    private _errorMensaje: string;
    private _idEmpresa: number;
    private _nombreEmpresa: string;

    constructor() {
        super();
        this._tipo = '';
        this._tipoOrigen = '';
        this._estado = 'pendiente';
        this._totalRegistros = 0;
        this._procesados = 0;
        this._fallos = 0;
        this._errorMensaje = '';
    }

    // Getters y Setters
    public set tipo(tipo: string) { this._tipo = tipo; }
    public get tipo(): string { return this._tipo; }

    public set tipoOrigen(tipoOrigen: string) { this._tipoOrigen = tipoOrigen; }
    public get tipoOrigen(): string { return this._tipoOrigen; }

    public set estado(estado: string) { this._estado = estado; }
    public get estado(): string { return this._estado; }

    public set totalRegistros(total: number) { this._totalRegistros = total; }
    public get totalRegistros(): number { return this._totalRegistros; }

    public set procesados(procesados: number) { this._procesados = procesados; }
    public get procesados(): number { return this._procesados; }

    public set fallos(fallos: number) { this._fallos = fallos; }
    public get fallos(): number { return this._fallos; }

    public set errorMensaje(msg: string) { this._errorMensaje = msg; }
    public get errorMensaje(): string { return this._errorMensaje; }

    public set idEmpresa(id: number) { this._idEmpresa = id; }
    public get idEmpresa(): number { return this._idEmpresa; }

    public set nombreEmpresa(nombre: string) { this._nombreEmpresa = nombre; }
    public get nombreEmpresa(): string { return this._nombreEmpresa; }

    public get porcentaje(): number {
        if (this._totalRegistros === 0) return 0;
        return Math.round((this._procesados / this._totalRegistros) * 100);
    }

    async cargarDatos(objeto: Record<string, any>) {
        this._tipo = objeto.tipo;
        this._tipoOrigen = objeto.tipo_origen;
        this._estado = objeto.estado;
        this._totalRegistros = objeto.total_registros;
        this._procesados = objeto.procesado;
        this._fallos = objeto.fallos;
        this._errorMensaje = objeto.error_mensaje;
        this._idEmpresa = objeto.id_empresa;
        this._nombreEmpresa = objeto.nombre_empresa;
    }

    async cargarObjeto(objeto: Record<string, any>) {
        await super.cargarObjeto(objeto);
        await this.cargarDatos(objeto);
    }

    async getFormGroup(): Promise<FormGroup> {
        let fg = await super.getFormGroup();
        fg.addControl("tipo", new FormControl(this._tipo));
        fg.addControl("tipo_origen", new FormControl(this._tipoOrigen));
        fg.addControl("estado", new FormControl(this._estado));
        fg.addControl("total_registros", new FormControl(this._totalRegistros));
        fg.addControl("procesado", new FormControl(this._procesados));
        fg.addControl("fallos", new FormControl(this._fallos));
        fg.addControl("error_mensaje", new FormControl(this._errorMensaje));
        fg.addControl("id_empresa", new FormControl(this._idEmpresa));
        fg.addControl("nombre_empresa", new FormControl(this._nombreEmpresa));
        return fg;
    }

    public static get columsOnLista(): Record<string, any>[] {
        return [
            { field: 'nombre', label: 'Nombre', type: 'text' },
            { field: 'tipo', label: 'Tipo', type: 'text' },
            { field: 'tipo_origen', label: 'Origen', type: 'text' },
            { field: 'estado', label: 'Estado', type: 'text' },
            { field: 'total_registros', label: 'Total', type: 'number' },
            { field: 'procesado', label: 'Procesados', type: 'number' }
        ]
    }
}